export default "__VITE_ASSET__9oCpvm5Q__"